// DashboardSelectorCard
// Renders the "Dashboard Selection" card — the dropdown to pick a dashboard
// and the Refresh Dashboards button.
// All state and handlers are owned by ConsoleDashboard.tsx and passed in as props.

import React from 'react';
import { ConsoleDashboardSummary } from '../../../types';

interface DashboardSelectorCardProps {
  dashboards: ConsoleDashboardSummary[];
  selectedDashboardId: string;
  setSelectedDashboardId: (v: string) => void;
  loadingDashboards: boolean;
  loadDashboards: () => Promise<void>;
}

const DashboardSelectorCard: React.FC<DashboardSelectorCardProps> = ({
  dashboards,
  selectedDashboardId,
  setSelectedDashboardId,
  loadingDashboards,
  loadDashboards,
}) => {
  return (
    <div className="console-card">
      <h2>Dashboard Selection</h2>
      {loadingDashboards ? <p>Loading dashboards...</p> : null}
      <label>
        Dashboard
        <select
          value={selectedDashboardId}
          onChange={(e) => setSelectedDashboardId(e.target.value)}
          required
        >
          <option value="">Select dashboard</option>
          {dashboards.map((row) => (
            <option key={row.dashboard_id} value={row.dashboard_id}>
              {row.name}
            </option>
          ))}
        </select>
      </label>
      <button type="button" onClick={() => void loadDashboards()} style={{ marginTop: '0.6rem' }}>
        Refresh Dashboards
      </button>
    </div>
  );
};

export default DashboardSelectorCard;